/**
 * 素材收选
 */

import React from 'react';
import { useMemo, useContext } from 'react';
import { connect } from 'react-redux';
import { updaterRoute } from '@/store/menus';
import { getQuery } from '@/common/utils';
import TabNav, { TabNavItemType } from '@/components/slide-menu/tab-nav';
import { useRouteMatch } from 'react-router-dom';
import { transformPlantformMenu } from '@/components/slide-menu/transformdata';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import childMenus from './route-config';
import RuleIconText from '@/pages/platform-marketing-position/resource-detail/material-collection/components/rule-icon';
import PalletInform from '@/pages/platform-marketing-position/resource-detail/inform';

const MaterialCollection = (props) => {
  const { roomId, blockId, activityId, permission } = useContext(ContextProviderMenus);
  let isManager = !!permission.role && [1, 2, 3].includes(permission.role);
  const tabData = [
    {
      title: (
        <div>
          分配提报
          <Tooltip placement="right" title="原提报流程">
            <QuestionCircleOutlined style={{ marginLeft: 4 }} />
          </Tooltip>
        </div>
      ),
      order: 1,
      key: 'tibao_activity',
      path: `/activity-manage/myCreate/daily-activities-manager/materials/distribute?entry=${
        isManager ? 0 : 1
      }&activityId=${activityId}&from=acore&hideTab=1&id=${activityId}&receivingType=1`,
    },
    {
      title: RuleIconText(),
      order: 2,
      key: 'rule_selector',
      path: `/activity-manage/myCreate/daily-activities-manager/materials/rule-collection?activityId=${activityId}&roomId=${roomId}`,
    },
    {
      title: '我的素材',
      order: 4,
      key: 'material_manage',
      path: `/activity-manage/myCreate/daily-activities-manager/materials/manage?entry=0&activityId=${activityId}&from=acore&hideTab=1&id=${activityId}`,
    },
  ];
  const getTab = () => {
    if (!permission?.modules?.tabs) return;
    const tab = permission.modules?.tabs;
    const result = [];
    for (let i in tab) {
      if (tab[i] === 1) {
        result.push(tabData.find((item) => item.key === i));
      }
    }
    result.splice(2, 0, {
      title: (
        <div>
          规则邀约
          <Tooltip
            placement="right"
            title="创建收品池及场次，然后通过选择规则标签圈选商品，邀约商品对应的采销、商家等角色提报个性化素材。"
          >
            <QuestionCircleOutlined style={{ marginLeft: 4 }} />
          </Tooltip>
        </div>
      ),
      order: 3,
      key: 'rule_invite',
      path: `/activity-manage/myCreate/daily-activities-manager/materials/invite?entry=${
        isManager ? 0 : 1
      }&activityId=${activityId}&from=acore&hideTab=1&id=${activityId}&receivingType=2`,
    });
    return result.filter((item) => item !== undefined).sort((a, b) => a.order - b.order);
  };
  return (
    <ChannelContentHasSideMenu menus={getTab()} blockId={blockId} roomId={roomId} activityId={activityId}>
      {props.children}
    </ChannelContentHasSideMenu>
  );
};

// 有侧边栏
function ChannelContentHasSideMenu({ menus = [], roomId, children, blockId, activityId }) {
  // let { path: currentPageConfigPath } = useRouteMatch();
  // let urlParams = `?roomId=${roomId}&activityId=${activityId}`;

  // // 外部连接不会出现在routeconfig中，menuItems无法通过children自动获取
  // let menuItems = useMemo(() => transformPlantformMenu(menus, currentPageConfigPath, urlParams), [
  //   menus,
  //   currentPageConfigPath,
  //   urlParams,
  // ]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: 15 }}>
      <PalletInform roomId={roomId} isDaily={true} activityId={activityId} />
      <TabNav menuItems={menus} layout="inline" linkParams={{ roomId, blockId }} />
      <div style={{ flexGrow: '1', minWidth: 0 }}>{children}</div>
    </div>
  );
}

export default connect(undefined, { updaterRoute })(MaterialCollection);
